export default __webpack_public_path__ + "static/media/Satyapira Choudhury.8ae5fea4.jpg";